import {defineStore} from 'pinia';
import {computed, ref} from 'vue';
import {isAlipayBrowser, removeCodeQuery} from '@/utils';
import {useGlobSetting} from '@/config';
import {getAliOpenIdApi, getWxOpenIdApi} from "@/api";
import {isEmpty} from "@/libs/functions";

export const useUserStore = defineStore(
    'userStore',
    () => {
        const token = ref<string>();
        const openId = ref<string>();
        const openQuery = ref<Recordable>({});

        const isLogin = computed(() => !isEmpty(openId.value));

        function setOpenId(val: string) {
            openId.value = val;
        }

        function getOpenId() {
            return openId.value;
        }

        const getWxCode = () => {
            return new Promise((resolve, reject) => {
                uni.login({
                    // #ifdef MP-WEIXIN
                    provider: 'weixin',
                    // #endif
                    success: ({code}) => resolve(code),
                    fail: (error) => reject(error),
                });
            });
        };

        function getH5AuthCode() {
            // #ifdef H5
            const {wx_appid, ali_appid} = useGlobSetting();
            return new Promise(() => {
                let authLocation = '';
                let app_id = isAlipayBrowser() ? ali_appid : wx_appid;
                const redirect_uri = encodeURIComponent(removeCodeQuery(window.location.href));

                if (isAlipayBrowser()) {
                    authLocation = `https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=${app_id}&scope=auth_base&redirect_uri=${redirect_uri}&state=init`;
                } else {
                    authLocation = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${app_id}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
                }

                window.location.href = authLocation;
            });
            // #endif
        }

        function getUserOpenId(code: string) {
            return new Promise(async (resolve) => {
                const getOpenIdMethod = isAlipayBrowser() ? getAliOpenIdApi : getWxOpenIdApi;
                getOpenIdMethod({code}).then((response: Recordable) => {
                    setOpenId(response.openid);
                    resolve(response.openid);
                }).catch((error) => {
                    uni.reLaunch({url: `/pages/error/error?msg=授权失败：${error.message}，请重新扫码`,})
                });
            })
        }

        return {
            token,
            openId,
            isLogin,
            openQuery,
            setOpenId,
            getOpenId,
            getH5AuthCode,
            getUserOpenId,
        };
    }
);
